import React from 'react';
import { CloseOutlined, EyeOutlined } from '../SbIcons/SbIcons';
import SbButton from '../SbButton/SbButton';
import SbTooltip from '../SbTooltip/SbTooltip';
import { PillWrapperStyled, FileNameTextStyled } from './SbFilePill.styles';

/**
 * Displays an uploaded file with preview and remove actions.
 *
 * compact=false (default) — pill with background, used in toolbars and form areas.
 * compact=true            — inline, icon-only, used inside table cells.
 */
const SbFilePill = ({ fileName, onPreview, onRemove, compact = false }) => (
  <PillWrapperStyled $compact={compact}>
    {!compact && (
      <FileNameTextStyled>{fileName}</FileNameTextStyled>
    )}
    {onPreview && (
      <SbTooltip title={compact ? `${fileName} — click to preview` : undefined}>
        <SbButton
          buttonType="action"
          size="small"
          icon={compact ? <EyeOutlined /> : undefined}
          onClick={onPreview}
        >
          {compact ? null : 'Preview file'}
        </SbButton>
      </SbTooltip>
    )}
    {onRemove && (
      compact ? (
        <SbTooltip title="Remove file">
          <SbButton
            buttonType="action"
            size="small"
            icon={<CloseOutlined />}
            onClick={onRemove}
          />
        </SbTooltip>
      ) : (
        <SbButton
          buttonType="action"
          size="small"
          icon={<CloseOutlined />}
          onClick={onRemove}
        />
      )
    )}
  </PillWrapperStyled>
);

export default SbFilePill;
